import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class GgwProfileService {

  constructor(private http: HttpClient) { }

  getGgwProfileStrategyOptions() {
    return this.http
      .get(`/api/ggw-profile-strategy-options`);
  }

  getGgwRouteStrategyOptions() {
    return this.http
      .get(`/api/ggw-route-strategy-options`);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-profiles/services/ggw-profile.service.ts